import classNames from "classnames";

interface WrapperProps {
  children: React.ReactNode;
  className?: string;
  props?: any;
}

export const Wrapper = ({ children, props, className }: WrapperProps) => (
  <div
    {...props}
    className={classNames("border-primary rounded-lg border", className)}
  >
    {children}
  </div>
);
